import type { FunctionalComponent } from 'preact';

interface Props {
  /** 누르면 실행할 동작. 없으면 브라우저 히스토리 뒤로. */
  onBack?: () => void;
  label?: string;
}

/** 시안 header.title 의 좌측 뒤로가기 버튼. */
export const NavBack: FunctionalComponent<Props> = ({ onBack, label = '뒤로' }) => (
  <button
    type="button"
    class="nav-back"
    aria-label={label}
    onClick={() => (onBack ? onBack() : window.history.back())}
  >
    <img src="/images/arrow-left.png" alt="" />
  </button>
);
